export default __webpack_public_path__ + "static/Natural_Light_Indoor_640kbps-7761ce1038639126df2aed22f55198d1.avif";